module.exports = __webpack_public_path__ + "assets/img/comp_1.e31fb850.png";